export default "__VITE_ASSET__cf400d76__"